export function IsAngleInRange(
  angleInRadians: number,
  lowerBound: number,
  upperBound: number
): boolean {
  const angleInDegrees = (angleInRadians * 180) / Math.PI;
  return angleInDegrees >= lowerBound && angleInDegrees <= upperBound;
}
